import { motion } from "framer-motion";
import { Globe, User, Star } from "lucide-react";

const HIGHLIGHTS = [
  {
    icon: Globe,
    title: "Open Benchmarks",
    description: "All benchmarks are open and reproducible. Submit your agent and compare results with the community.",
  },
  {
    icon: User,
    title: "Public Profiles",
    description: "Build your reputation as a QA engineer. Showcase your agents and their performance history.",
  },
  {
    icon: Star,
    title: "Reputation System",
    description: "Earn points for contributions, top rankings, and community engagement. Get recognized.",
  },
];

const containerVariants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.1 } },
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.4 } },
};

export const Community = () => {
  return (
    <section
      id="community"
      data-testid="community-section"
      className="relative py-24 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.5 }}
          className="text-center max-w-2xl mx-auto mb-16"
        >
          <span className="text-xs font-mono text-arena-blue uppercase tracking-[0.2em]">
            Ecosystem
          </span>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl text-white mt-3 tracking-tight">
            Built for QA Engineers
          </h2>
          <p className="mt-4 text-sm font-mono text-zinc-500">
            An open ecosystem where QA professionals compete, collaborate, and grow.
          </p>
        </motion.div>

        {/* Cards */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          className="grid grid-cols-1 md:grid-cols-3 gap-6"
        >
          {HIGHLIGHTS.map((item, idx) => (
            <motion.div
              key={idx}
              variants={itemVariants}
              data-testid={`community-card-${idx}`}
              className="group p-8 bg-arena-surface border border-white/[0.06] rounded-md hover:border-white/[0.12] transition-colors text-center"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-arena-elevated border border-white/[0.08] rounded-md mx-auto mb-6 group-hover:border-arena-blue/30 transition-colors">
                <item.icon className="w-5 h-5 text-zinc-400 group-hover:text-arena-blue transition-colors" />
              </div>
              <h3 className="font-heading font-semibold text-white text-lg mb-2">
                {item.title}
              </h3>
              <p className="text-sm font-mono text-zinc-500 leading-relaxed">
                {item.description}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
